import { render, staticRenderFns } from "./DocumentTexts.vue?vue&type=template&id=039851b8&lang=pug&"
import script from "./DocumentTexts.vue?vue&type=script&lang=js&"
export * from "./DocumentTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports